export function addOverflow(string: string | number, lengthToOverflow = 30): string {
  const safeStr = typeof string === "number" ? String(string) : string;
  if (safeStr.length > lengthToOverflow) {
    return `${safeStr.slice(0, lengthToOverflow)}...`;
  }
  return safeStr;
}
